import { QueryClient } from '@tanstack/react-query';

/**
 * O cliente de cache do TanStack, como módulo — não como variável do `main.tsx`.
 *
 * Nasceu dentro do `main.tsx`, e isso bastava enquanto só o React o usava. O
 * serviço de reconexão (`features/atendimento/reconexao.ts`) precisa escrever no
 * cache de fora da árvore de componentes: ele é criado junto com o socket, antes
 * de qualquer tela existir, exatamente pra não depender de um `useEffect` ter
 * rodado. Sem um módulo, ele não teria como alcançar o cache.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 2,
      // Cache fica por até 24h no localStorage. Mantém telas "congeladas"
      // mesmo após F5 com backend off — refetch on reconnect atualiza dados.
      gcTime: 1000 * 60 * 60 * 24,
    },
  },
});
